import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';

// How often to re-check. Long enough not to be chatty, short enough that
// someone who leaves the tab open all day notices within the hour.
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

const BUNDLE_RE = /main\.[a-z0-9]+\.js/;

// The filename of the main bundle THIS tab is currently running. CRA puts a
// content hash in it, so it changes on every deploy that changed the code.
const runningBundle = () => {
  const el = document.querySelector('script[src*="/static/js/main."]');
  const match = el?.src?.match(BUNDLE_RE);
  return match ? match[0] : null;
};

// Warns when the tab is running code older than what's deployed. This app is
// a single-page app: the JS is fetched once when the page opens and then
// keeps running untouched, so deploying a fix does NOT reach a tab someone
// left open - which is exactly how a fixed double-submit bug still produced
// duplicate orders nine hours after the fix shipped.
const UpdateAvailableBanner = () => {
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    const running = runningBundle();
    // No hashed bundle = dev server, nothing to compare against. localhost
    // also covers the Android app, which serves these files from inside the
    // APK where they can never differ from what's running (it updates by
    // installing a new APK instead).
    if (!running || window.location.hostname === 'localhost') return undefined;

    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch(`/index.html?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const deployed = (await res.text()).match(BUNDLE_RE);
        if (!cancelled && deployed && deployed[0] !== running) setOutdated(true);
      } catch (err) {
        // Offline or the request was blocked - just try again next tick.
      }
    };

    check();
    const interval = setInterval(check, CHECK_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  if (!outdated) return null;

  return (
    <Snackbar open anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ mt: 1 }}>
      <Alert
        severity="warning"
        sx={{ alignItems: 'center' }}
        action={
          <Button color="inherit" size="small" variant="outlined" onClick={() => window.location.reload()}>
            حدّث دلوقتي
          </Button>
        }
      >
        في نسخة أحدث من النظام — لازم تعمل تحديث للصفحة عشان تشتغل عليها
      </Alert>
    </Snackbar>
  );
};

export default UpdateAvailableBanner;
